/**
 * Report issue 진입점을 한 곳에서 받는다 (STUDIO-HOME-004).
 *
 * 진입점이 둘이라 게스트 판정을 각 진입점에 복제하지 않는다. 좌측 패널과
 * 에러 토스트 모두 store 를 열기만 하고, 로그인 여부는 여기서 한 번 본다.
 *
 * 게스트에게 항목을 숨기지 않는다. 숨기면 리포트를 보낼 수 있다는 사실 자체를
 * 모른다. 대신 정본 로그인 화면으로 보낸다.
 */

import React from "react";

import LoginRequiredPopup from "./Dashboards/LoginRequiredPopup";
import ReportIssueModal from "./ReportIssueModal";
import { useAuth } from "../contexts/AuthContext";
import { useExitGuestToLogin } from "../hooks/auth/useExitGuestToLogin";
import { useReportIssueStore } from "../store/reportIssueStore";

/**
 * 로그인 유도는 실제로 띄울 때만 mount 한다. 이 hook 은 router 를 쓰므로,
 * 앱 shell 이 항상 들고 있으면 router 밖에서도 호출되는 셈이 된다.
 */
const ReportIssueSignInGate: React.FC<{ onClose: () => void }> = ({
  onClose,
}) => {
  const exitGuestToLogin = useExitGuestToLogin();
  return (
    <LoginRequiredPopup
      open
      onCancel={onClose}
      onGoLogin={() => {
        onClose();
        // 정본 로그인 화면은 /login 하나다.
        void exitGuestToLogin();
      }}
    />
  );
};

const ReportIssueHost: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const open = useReportIssueStore((state) => state.open);
  const entry = useReportIssueStore((state) => state.entry);
  const modalSessionId = useReportIssueStore((state) => state.modalSessionId);
  const closeReportIssue = useReportIssueStore((state) => state.closeReportIssue);
  const markReportSent = useReportIssueStore((state) => state.markReportSent);

  const needsSignIn = !isAuthenticated || Boolean(user?.isGuest);

  if (!open) return null;

  if (needsSignIn) {
    return <ReportIssueSignInGate onClose={closeReportIssue} />;
  }

  return (
    <ReportIssueModal
      key={`${modalSessionId}:${user?.uid}`}
      sessionId={modalSessionId}
      entry={entry}
      open
      onClose={closeReportIssue}
      onSent={() => markReportSent(modalSessionId)}
    />
  );
};

export default ReportIssueHost;
